import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App lang={document.getElementById('root').getAttribute('lang')} />
  </React.StrictMode>,
  document.getElementById('root')
);
